import React, { useEffect, useState } from "react";
import NewsFullPage from "../components/commons/NewsFullPage";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SiteMap from "../components/SiteMap";
import axios from "axios";
import { API_URL } from "../utils/api";

/**
 * Pagina de noticia acessada pela rota direta (/<link>).
 * Recebe `news` completo ou apenas `link`; neste caso busca o conteudo na API.
 */
const NewsItem = ({ news: initialNews = null, link = "" }) => {
    const [width, setWidth] = useState(window.innerWidth);
    const [news, setNews] = useState(initialNews?.ck ? initialNews : null);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        const target = link || initialNews?.link;

        if (!news && target) {
            axios
                .get(`${API_URL}/links?link=${encodeURIComponent(target)}`, {
                    headers: { "Content-Type": "application/json;charset=utf-8" },
                    crossDomain: true,
                })
                .then((resp) => setNews(resp.data[0] || null))
                .catch(() => setNews(null));
        }

        window.scrollTo({
            top: 0,
            behavior: "smooth", // for smoothly scrolling
        });

        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [link]);

    const isMobile = width <= 768;

    return (
        <>
            <header>
                <Header isMobile={isMobile} />
            </header>
            <main id="conteudo-principal">
                <h1 className="sr-only">Notícia</h1>
                {news && <NewsFullPage news={news} isMobile={isMobile} />}
            </main>
            <footer>
                <Footer />
                <SiteMap />
            </footer>
        </>
    );
};

export default NewsItem;
